import React from 'react';

import classnames from 'classnames';

import { MODALS } from 'global-constants';

import WithOpenModal from 'shared/HOCs/WithOpenModal';

import Image from 'shared/components/Image';
import Button from 'shared/components/Button';

import styles from './styles.module.scss';

const GenericSection = ({
  title,
  openModal,
  description,
  reverse = false,
  withImageShadow = false,
  image
}) => (
  <div
    className={classnames(styles.container, 'container', {
      [styles.reverse]: reverse
    })}>
    <div className={styles.left}>
      <div className={styles.title}>{title}</div>
      <div className={styles.description}>{description}</div>
      <Button
        color="orange-gradient"
        className={styles.button}
        onClick={() => openModal({ modalName: MODALS.SIGNUP })}>
        Sign up for Free
      </Button>
    </div>
    <div
      className={classnames(styles.imageContainer, {
        [styles.withShadow]: withImageShadow
      })}>
      <div className="remove-xs">
        <Image src={image} width="642" height="440" />
      </div>
      <div className="remove-sm-min">
        <Image src={image} width="100%" />
      </div>
    </div>
  </div>
);

export default WithOpenModal(GenericSection);
